import { useEffect, useMemo, useState } from "react";
import API from "../../../../../services/api";

function useCatering() {
  const [packages, setPackages] = useState([]);

  const [loading, setLoading] = useState(true);

  const [deleteLoading, setDeleteLoading] = useState(false);

  const [search, setSearch] = useState("");

  const [category, setCategory] = useState("All");

  const [selectedPackage, setSelectedPackage] = useState(null);

  const [showForm, setShowForm] = useState(false);

  const [showDelete, setShowDelete] = useState(false);

  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    fetchPackages();
  }, []);

  const fetchPackages = async () => {
    try {
      setLoading(true);

      const { data } = await API.get("/catering/my-packages");

      setPackages(data.packages || []);

    } catch (err) {

      console.log(err);

    } finally {

      setLoading(false);

    }
  };

  const filteredPackages = useMemo(() => {

    return packages.filter((item) => {

      const matchesSearch =
        item.packageName
          .toLowerCase()
          .includes(search.toLowerCase());

      const matchesCategory =
        category === "All" ||
        item.category === category;

      return matchesSearch && matchesCategory;

    });

  }, [packages, search, category]);

  const openAddModal = () => {

    setSelectedPackage(null);

    setShowForm(true);

  };

  const openEditModal = (pkg) => {

    setSelectedPackage(pkg);

    setShowForm(true);

  };

  const closeForm = () => {

    setSelectedPackage(null);

    setShowForm(false);

  };

  const openDeleteModal = (pkg) => {

    setSelectedPackage(pkg);

    setShowDelete(true);

  };

  const closeDelete = () => {

    setSelectedPackage(null);

    setShowDelete(false);

  };

  const openDetails = (pkg) => {

    setSelectedPackage(pkg);

    setShowDetails(true);

  };

  const closeDetails = () => {

    setSelectedPackage(null);

    setShowDetails(false);

  };

  const deletePackage = async () => {

    try {

      setDeleteLoading(true);

      await API.delete(
        `/catering/${selectedPackage._id}`
      );

      fetchPackages();

      closeDelete();

    } catch (err) {

      console.log(err);

    } finally {

      setDeleteLoading(false);

    }

  };

  return {

    loading,

    packages,

    filteredPackages,

    search,

    setSearch,

    category,

    setCategory,

    selectedPackage,

    showForm,

    showDelete,

    showDetails,

    deleteLoading,

    fetchPackages,

    openAddModal,

    openEditModal,

    closeForm,

    openDeleteModal,

    closeDelete,

    openDetails,

    closeDetails,

    deletePackage,

  };
}

export default useCatering;